import type {ContentReviewDto, TodayDashboardDto} from '@devmil/contracts';
import {useCallback, useEffect, useState} from 'react';

import {usePanel} from '../../app/PanelProvider.js';

export interface TodayDashboardState {
  today: TodayDashboardDto;
  selected: ContentReviewDto;
  select: (contentVersionId: string) => void;
  /** Aberto pelo botão `Pedir alteração`, fechado ao trocar de peça. */
  changeBoxOpen: boolean;
  openChangeBox: () => void;
  closeChangeBox: () => void;
}

export const useTodayDashboard = (): TodayDashboardState | null => {
  const {snapshot, paused} = usePanel();
  const [selectedId, setSelectedId] = useState<string | null>(null);
  const [changeBoxOpen, setChangeBoxOpen] = useState(false);

  const openChangeBox = useCallback(() => {
    setChangeBoxOpen(true);
  }, []);

  const closeChangeBox = useCallback(() => {
    setChangeBoxOpen(false);
  }, []);

  // Pausar fecha o formulário aberto. Deixar um campo de decisão em pé com o
  // botão desligado convida a escrever um pedido que não vai a lugar nenhum.
  useEffect(() => {
    if (paused) {
      setChangeBoxOpen(false);
    }
  }, [paused]);

  const select = useCallback((contentVersionId: string) => {
    setSelectedId(contentVersionId);
    // Trocar de peça fecha o formulário: comentário escrito para uma peça não
    // pode seguir aberto sobre outra.
    setChangeBoxOpen(false);
  }, []);

  if (!snapshot) {
    return null;
  }

  const {today} = snapshot;
  const selected =
    today.queue.find((piece) => piece.contentVersionId === selectedId) ??
    today.queue[0];

  if (!selected) {
    return null;
  }

  return {
    today,
    selected,
    select,
    changeBoxOpen,
    openChangeBox,
    closeChangeBox,
  };
};
